































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import BaseStringInput from '@/components/BaseStringInput.vue';
import BaseBooleanInput from '@/components/BaseBooleanInput.vue';
import ReferencedModel from '@/components/ReferencedModel.vue';
import AddProperty from '@/components/AddProperty.vue';
import { generateGuid } from '../utils';
import draggable from 'vuedraggable';
import { BaseDTO } from '@/types/';

@Component({
  name: 'RecursiveCollapse',
  components: {
    BaseStringInput,
    ReferencedModel,
    BaseBooleanInput,
    AddProperty,
    draggable
  }
})
export default class RecursiveCollapse extends Vue {
    @Prop({ type: Object, required: true }) readonly data!: BaseDTO;
    @Prop({ type: String, default: '' }) readonly id!: string;
    @Prop({ type: Boolean, required: true, default: false }) readonly isSubChild!: boolean;
    @Prop(String) readonly propertyName!: string;
    @Prop(String) readonly parentEntry!: string;

    dataModel: BaseDTO = new BaseDTO();
    newPropertyName = '';
    editPropertyName = false;
    $lodash: any;
    isOpen = false;
    $eventBus: any;

    get isEndpoint (): boolean {
      return this.$route.params.type === 'endpoints';
    }

    get models (): any {
      return this.$store.state.models;
    }

    get siblings (): string[] {
      return Object.keys(this.data.value);
    }

    get endpointUrl (): string {
      return `${window.location.origin}/${this.id}`;
    }

    get sortable () {
      // Convert value object to array for making it sortabel
      return this.dataModel.value ? Object.entries((this.dataModel.value as any)) : [];
    }

    set sortable (value) {
      // Convert sorted valye array back to object
      this.dataModel.value = Object.fromEntries(value);
    }

    @Watch('data')
    onDataChange (value: BaseDTO): void {
      this.dataModel = value;
      this.dataModel.removeKey = value.removeKey || false;
    }

    created (): void {
      this.newPropertyName = this.propertyName;
      this.dataModel = this.data;
      this.dataModel.removeKey = this.data.removeKey || false;
      this.isOpen = localStorage.getItem(this.data.id) === 'true';
    }

    mounted () {
      this.$eventBus.$on('TRIGGER_PROPERTY_EDIT', (id: string) => {
        if (id === this.dataModel.id) {
          this.editPropName();
          this.isOpen = true;
        }
      });
    }

    setCollapseState () {
      if (!this.editPropertyName) {
        this.isOpen = !this.isOpen;
        localStorage.setItem(this.data.id, this.isOpen.toString());
      }
    }

    editPropName (): void {
      this.editPropertyName = !this.editPropertyName;
      this.$nextTick(() => {
        (this.$refs.propertyName as any).focusInput();
        (this.$refs.propertyName as any).$el.getElementsByTagName('input')[0].select();
      });
    }

    addNewProperty (type: string, value: string): void {
      let newProperty: BaseDTO = new BaseDTO();
      const propertyName: string = value;
      if (type !== 'object' && type !== 'array') {
        switch (type) {
          case 'string':
            newProperty = new BaseDTO({
              type: type,
              id: generateGuid(),
              value: ''
            });
            break;
          case 'number':
            newProperty = new BaseDTO({
              type: type,
              id: generateGuid(),
              value: '0'
            });
            break;
          case 'boolean':
            newProperty = new BaseDTO({
              type: type,
              id: generateGuid(),
              value: 'false'
            });
            break;
          case 'model':
            newProperty = new BaseDTO({
              type: type,
              id: generateGuid(),
              value: ''
            });
            break;
        }
      } else {
        // Handle objects and arrays
        newProperty = type === 'array' ? new BaseDTO({ type: type, timesToRepeat: 1, id: generateGuid() }) : new BaseDTO({ type: type, id: generateGuid() });
      }

      const clonedObject = this.$lodash.cloneDeep(this.dataModel.value);
      clonedObject[propertyName] = newProperty;
      this.dataModel.value = clonedObject;

      this.$nextTick(() => {
        this.$eventBus.$emit('TRIGGER_PROPERTY_EDIT', newProperty.id);
      });
    }

    updateModel (): void {
      this.$store.dispatch('updateModelProperty', {
        propertyName: this.newPropertyName,
        oldPropertyName: this.propertyName,
        value: this.dataModel
      });
    }

    closePropEditor (): void {
      setTimeout(() => {
        this.editPropertyName = false;
      }, 100);
    }

    deleteProp (): void {
      this.$store.dispatch('deleteModelProperty', {
        id: this.dataModel.id
      });
    }
}
